module.exports = __webpack_public_path__ + "img/focus-wb.b19c156a.png";